import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import {
    ShieldCheck,
    User,
    LockKeyhole,
    ArrowRight,
    Eye,
    EyeOff
} from "lucide-react";

import NotificationsAlert from "../../services/NotificationsAlert";
import Conect from "../../services/api/Conect";

import "./styles.css";
import Logo from "../../assets/fp-logo.png";

const UserLogin = () => {

    const navigate = useNavigate();

    const [login, setLogin] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    localStorage.setItem("fphistory", "Sistema");

    useEffect(() => {

        const token = localStorage.getItem("fptoken");

        if (token) {
            verifyToken(token);
        }
    // eslint-disable-next-line
    }, []);

    const verifyToken = async (token) => {

        try {

            const auth = await Conect.get(`/dmVyaWZ5YXV0aA==${token}`);

            if (auth.data.erro === "false") {

                NotificationsAlert("default", "", auth.data.msg);

                navigate("/home");

            } else {

                navigate("/login");

            }

        } catch (error) {

            console.error("Erro ao verificar token:", error);

        }

    };

    const handleLogin = async (e) => {

        e.preventDefault();

        setLoading(true);

        try {

            const response = await Conect.post("/login", {
                login,
                pass: password,
            });

            const res = response.data;

            if (res.erro === true) {

                NotificationsAlert(
                    res.status === 401 ? "danger" : "warning",
                    res.msg
                );

                setLoading(false);

                return;
            }

            const userData = res.data;

            localStorage.setItem("fpid", userData.id);
            localStorage.setItem("fpemail", userData.email);
            localStorage.setItem("fpfirstName", userData.firstName);
            localStorage.setItem("fplastName", userData.lastName);
            localStorage.setItem("fpaccessLevel", userData.accessLevel);
            localStorage.setItem("fptoken", userData.token);

            NotificationsAlert(
                "default",
                `Olá ${userData.firstName}!`,
                ""
            );

            navigate("/home");

        } catch (error) {

            NotificationsAlert(
                "danger",
                "Erro",
                "Falha na autenticação."
            );

            console.error("Login error:", error);

        } finally {

            setLoading(false);

        }

    };

    return (
        <div className="login-page">

            <div className="login-bg-gradient"></div>
            <div className="login-bg-blur blur-green"></div>
            <div className="login-bg-blur blur-yellow"></div>
            <div className="login-bg-grid"></div>
            <div className="login-left">

                <div className="login-brand">

                    <img
                        src={Logo}
                        alt="Logo"
                    />

                    <h1>
                        FP MotorHome - Excelência na Estrada!
                    </h1>

                    <p>
                        Controle completo de ordens,
                        clientes, veículos e operações.
                    </p>

                </div>

                <div className="login-info-cards">

                    <div className="login-info-card">
                        <ShieldCheck size={20} />
                        Ambiente seguro e criptografado
                    </div>

                    <div className="login-info-card">
                        🚗 Gestão completa de veículos
                    </div>

                    <div className="login-info-card">
                        📊 Dashboard operacional inteligente
                    </div>

                </div>

            </div>

            {/* RIGHT SIDE */}
            <div className="login-right">

                <div className="login-box">

                    <div className="login-box-header">

                        <span className="login-badge">
                            Sistema ERP
                        </span>

                        <h2>
                            Bem-vindo 👋
                        </h2>

                        <p>
                            Faça login para acessar o sistema.
                        </p>

                    </div>

                    <form
                        className="login-form"
                        onSubmit={handleLogin}
                    >

                        {/* LOGIN */}
                        <div className="login-input-group">

                            <label>
                                Usuário
                            </label>

                            <div className="login-input-wrapper">

                                <User size={18} />

                                <input
                                    type="text"
                                    placeholder="Digite seu login"
                                    value={login}
                                    onChange={(e) => setLogin(e.target.value)}
                                    required
                                />

                            </div>

                        </div>

                        {/* PASSWORD */}
                        <div className="login-input-group">

                            <label>
                                Senha
                            </label>

                            <div className="login-input-wrapper">

                                <LockKeyhole size={18} />

                                <input
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Digite sua senha"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />

                                <button
                                    type="button"
                                    className="login-password-toggle"
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    {showPassword ? (
                                        <EyeOff size={18} />
                                    ) : (
                                        <Eye size={18} />
                                    )}
                                </button>

                            </div>

                        </div>

                        {/* BUTTON */}
                        <button
                            type="submit"
                            className="login-submit-btn"
                            disabled={loading}
                        >

                            {loading ? (
                                <div className="login-loading"></div>
                            ) : (
                                <>
                                    Entrar no sistema
                                    <ArrowRight size={18} />
                                </>
                            )}

                        </button>

                    </form>

                    <div className="login-footer">
                        SakamottoSystem © 2026
                    </div>

                </div>

            </div>

        </div>

    );

};

export default UserLogin;